export class WebListaFornecedores {
   idFornecedor : number;
   nmDescricao : string;
   nrCnpj : string;
}